import { makeStyles } from '@material-ui/core/styles';

export const styles = {
  container: {
    position: 'relative'
  },
  layover: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height :'100%',
    opacity: 1
  },
  layoverHidden: {
    opacity: 0.3,
    transition: 'opacity 1000ms'
  }
}

export default makeStyles(styles)
